import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FilialState {
  currentFilialId: number | null;
  /** Касался ли человек переключателя в ЭТОЙ сессии браузера. */
  vybralSam: boolean;
  setCurrentFilial: (id: number | null) => void;
  zasev: (id: number | null) => void;
}

const STORAGE_KEY = 'opsmind_current_filial_id';

export const useFilialStore = create<FilialState>()(
  persist(
    (set) => ({
      currentFilialId: null,
      vybralSam: false,
      setCurrentFilial: (id) => set({ currentFilialId: id, vybralSam: true }),
      zasev: (id) => set({ currentFilialId: id }),
    }),
    {
      name: STORAGE_KEY,
      /*
       * ⛔ `s320` Д3: «КАСАЛСЯ ЛИ ПЕРЕКЛЮЧАТЕЛЯ» НЕ ХРАНИТСЯ МЕЖДУ ВХОДАМИ.
       * Сам выбор человека хранит СЕРВЕР (`users.tekushchiy_filial_id`), и он
       * же приезжает засевом; память браузера остаётся только на время сессии,
       * чтобы не мигать значением до ответа `/auth/me`.
       */
      partialize: (s) => ({ currentFilialId: s.currentFilialId }) as FilialState,
    }
  )
);

/**
 * Засев филиала с сервера (`s320`, Д3).
 *
 * ⛔ Зовётся из `useAuth` на каждый ответ `/auth/me`, но кладёт значение ТОЛЬКО
 * пока человек не переключал филиал сам: иначе ответ, пришедший после клика,
 * откатывал бы выбор назад. Выбор человека всегда старше правила.
 */
export function zasevFiliala(serverId: number | null, gotov: boolean): void {
  if (!gotov) return;
  const s = useFilialStore.getState();
  if (s.vybralSam) return;
  if (s.currentFilialId === serverId) return;
  s.zasev(serverId);
}
